import React from 'react';
import './FormRadioButton.css';

function FormRadioButton({ label, isChecked, onChange }) {
  return (
    <label className="radio-container m-0 mr-3" onClick={onChange}>
      <div className={`radio-button ${isChecked ? 'checked' : ''}`}>
        {isChecked && <div className="centerDot"></div>}
      </div>
      <span className="radio-button-label">{label}</span>
    </label>
  );
}

export default FormRadioButton;
